module.exports = __webpack_public_path__ + "img/mtc-detail.41b3ff43.jpg";